<template>
  <div class="wrapp-orders-filters">
    <div class="expand-filters">
      <transition
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut animate__faster">
        <div class="wrapp-filters" v-show="!showFilters">
          <div class="wrapp-selected" v-if="Object.keys(selectedFilters).length">
            <ul class="nav">
              <li v-for="(filter, index) in selectedFilters" :key="index" class="mr-3">
                <button class="cta btn btn-icon btn-icon-border-black btn-rounded pl-1 pr-3 py-1" @click.prevent="resetFilterProgrammatically(filter.resetMethod)">
                  <svg class="o-icon stroke-black mr-2"><use xlink:href="#close"></use></svg>
                  <span class="text">{{ filter.label }}</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="wrapp-expander-order" v-show="!Object.keys(selectedFilters).length" @click.prevent="toggleCollapse(true)">
            <button class="cta btn btn-icon-text-out">
              <svg class="o-icon fill-black"><use xlink:href="#filter"></use></svg>
              <span class="text">{{ $t('filter-orders') }}</span>
            </button>
          </div>
          <div class="wrapp-expander-icon" @click.prevent="toggleCollapse(true)">
            <button class="btn btn-none btn-icon btn-icon-small">
              <svg class="o-icon fill-black"><use xlink:href="#arrows-expand"></use></svg>
            </button>
          </div>
        </div>
      </transition>
    </div>
    <b-collapse id="orders-filters" :visible="showFilters" accordion="my-accordion" role="tabpanel">
      <b-row>
        <b-col cols="7">
          <b-row class="input-order-owener" no-gutters>
            <b-col cols="6">
              <b-form-group label-for="order-owener">
                <div class="wrapp-input-icon">
                  <button class="btn btn-icon btn-none" v-if="userFilterName.length" @click.prevent="resetSearchByName">
                    <svg class="o-icon stroke-black"><use xlink:href="#close-small"></use></svg>
                  </button>
                  <button class="btn btn-icon btn-none" v-else>
                    <svg class="o-icon"><use xlink:href="#search"></use></svg>
                  </button>
                </div>
                <base-input
                  name="order-owener"
                  classInput="rounded"
                  v-model="userFilterName"
                  type="text"
                  :autofocus="true"
                  :placeholder="$t('search-for-name-surname') + '*'"
                >
                </base-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <b-form-radio-group
                  v-model="userFilterSelected"
                  text-field="label"
                  :options="userFilter"
                  name="radio-sort"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="separator separator-right"></div>
        </b-col>
        <b-col cols="4">
          <div class="input-order-range">
            <vc-date-picker
            v-model="orderRange"
            title-position="left"
            mode="date"
            class="wrapp-date-picker"
            is-range>
              <template v-slot="{ inputValue, inputEvents}">
                <b-form-group>
                  <input
                  :value="`${(inputValue.start && inputValue.end) ? `${inputValue.start} – ${inputValue.end}` : ''}`"
                  :placeholder="$t('search-for-period')"
                  v-on="inputEvents.start" class="form-control rounded"/>
                  <div class="wrapp-input-icon">
                    <button class="btn btn-icon btn-none" v-if="(inputValue.start && inputValue.end)" @click.prevent="resetSearchRange">
                      <svg class="o-icon stroke-black"><use xlink:href="#close-small"></use></svg>
                    </button>
                    <button class="btn btn-icon btn-none" v-else>
                      <svg class="o-icon fill-black"><use xlink:href="#calendar-range"></use></svg>
                    </button>
                  </div>
                </b-form-group>
              </template>
            </vc-date-picker>
          </div>
        </b-col>
        <b-col cols="1">
          <div class="wrapp-collapser">
            <button class="btn btn-none btn-icon btn-icon-small" @click.prevent="toggleCollapse(false)">
              <svg class="o-icon fill-black"><use xlink:href="#arrows-collapse"></use></svg>
            </button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <b-form-group>
            <base-select
            name="order-status"
            v-model="orderStatusSelected"
            selectClass="select-rounded rounded"
            :options="orderStatuses"
            :searchable="false"
            :placeholder="$t('choose-order-status')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <div class="wrapp-actions d-flex align-items-center justify-content-end">
            <button class="cta btn btn-icon-text-out" @click.prevent="resetFilters">
              <span class="text">{{ $t('Remove')}}</span>
              <svg class="o-icon fill-black"><use xlink:href="#circle-close"></use></svg>
            </button>
            <button class="btn btn-primary btn-primary-small btn-primary-black btn-primary-with-icon btn-rounded ml-3" @click.prevent="applyFilter">
              <span class="text">{{ $t('apply')}}</span>
              <svg class="o-icon fill-white"><use xlink:href="#check"></use></svg>
            </button>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import Config from 'config'
import dayjs from 'dayjs'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseSelect from 'theme/components/Form/BaseSelect'

export default {
  name: 'OrdersFilters',
  data () {
    return {
      selectedFilters: {},
      showFilters: true,
      userFilter: [
        {
          value: 'customer_firstname',
          label: this.$t('firstname')
        },
        {
          value: 'customer_lastname',
          label: this.$t('lastname')
        }
      ],
      userFilterSelected: 'customer_firstname',
      userFilterName: '',
      rangeEdited: false,
      orderRange: {
        start: '',
        end: ''
      },
      orderStatusSelected: ''
    }
  },
  mounted () {
    this.setFiltersForComponent(this.$store.state.search.filtersApplied)
  },
  computed: {
    orderStatuses () {
      return Config.Theme.orderSatuses.map((status) => {
        return {
          ...status,
          label: this.$t(`order-status.${status.label}`)
        }
      })
    }
  },
  methods: {
    toggleCollapse (payload) {
      this.showFilters = payload
    },
    resetFilterProgrammatically (methodToCall) {
      methodToCall.call()
      this.applyFilter()
    },
    resetSearchByName () {
      this.userFilterName = ''
    },
    resetSearchRange () {
      this.orderRange = {
        start: '',
        end: ''
      }
    },
    resetOrderStatus () {
      this.orderStatusSelected = ''
    },
    resetFilters () {
      this.resetSearchByName()
      this.resetSearchRange()
      this.resetOrderStatus()
      this.applyFilter()
    },
    applyFilter () {
      this.selectedFilters = {}
      let composeQuery = []
      if (this.userFilterName) {
        composeQuery.push({
          field: `customer_name`,
          value: `${this.userFilterName}`,
          condition_type: 'like'
        })
        this.selectedFilters['userFilterName'] = {
          label: this.userFilterName,
          resetMethod: this.resetSearchByName
        }
      }
      if (this.orderRange.start && this.orderRange.end) {
        composeQuery.push({
          field: 'creation_date',
          value: `${dayjs(this.orderRange.start).format('YYYY-MM-DDTHH:mm:ss.000[Z]')}`,
          condition_type: 'from'
        }, {
          field: 'creation_date',
          value: `${dayjs(this.orderRange.end).add(23, 'hours').add(59, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000[Z]')}`,
          condition_type: 'to'
        })
        this.selectedFilters['orderRange'] = {
          label: `${dayjs(this.orderRange.start).format('DD/MM/YYYY')} – ${dayjs(this.orderRange.end).format('DD/MM/YYYY')}`,
          resetMethod: this.resetSearchRange
        }
      }
      if (this.orderStatusSelected && this.orderStatusSelected.value) {
        composeQuery.push({
          field: 'status',
          value: `${this.orderStatusSelected.value}`,
          condition_type: 'eq',
          label: `${this.orderStatusSelected.label}`
        })
        this.selectedFilters['status'] = {
          label: this.orderStatusSelected.label,
          resetMethod: this.resetOrderStatus
        }
      }
      this.resetPagination()
      this.$store.commit('search/setAppliedFilters', composeQuery)
      return this.$emit('filtersApplied', composeQuery, true)
    },
    setFiltersForComponent (filters = []) {
      this.setOrderRange(filters)
      filters.forEach(element => {
        switch (element.field) {
          case 'customer_name':
            this.userFilterName = element.value
            break
          case 'status':
            let orderStatusVar = {
              value: '',
              label: ''
            }
            if (element.label) {
              orderStatusVar.label = element.label
            }
            if (element.value) {
              orderStatusVar.value = element.value
            }
            this.orderStatusSelected = orderStatusVar
            break
        }
      })
    },
    resetPagination () {
      let pagination = {
        size: Config.Theme.paginationSize,
        start: 0,
        page: 1
      }
      this.$store.commit('orders/setPagination', pagination)
    },
    setOrderRange (allFilters) {
      let rangeDates = allFilters.filter(filter => filter.field === 'creation_date')
      if (rangeDates.length) {
        let filterDate = {
          start: '',
          end: ''
        }
        rangeDates.forEach(element => {
          if (element.condition_type && element.condition_type === 'from') {
            filterDate.start = element.value
          } else {
            filterDate.end = element.value
          }
        })
        this.orderRange = filterDate
      }
    }
  },
  components: {
    BaseInput,
    BaseSelect
  }
}
</script>
